import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.concat.js";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import { ApolloClient } from '@apollo/client/core';
import { ApolloLink } from '@apollo/client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from '@apollo/link-context';
import { InMemoryCache } from '@apollo/client/cache';
import lumosHeaders from './lumosHeaders';
import errorsMiddleware from './apolloErrorHandling';

var LumosApolloClient = /*#__PURE__*/function () {
  function LumosApolloClient(_ref) {
    var _ref$credentials = _ref.credentials,
        credentials = _ref$credentials === void 0 ? 'same-origin' : _ref$credentials,
        fragmentMatcher = _ref.fragmentMatcher,
        uri = _ref.uri,
        _ref$useApolloNetwork = _ref.useApolloNetworkErrorLog,
        useApolloNetworkErrorLog = _ref$useApolloNetwork === void 0 ? false : _ref$useApolloNetwork,
        fetchPolyfill = _ref.fetchPolyfill;

    _classCallCheck(this, LumosApolloClient);

    this.credentials = credentials;
    this.fragmentMatcher = fragmentMatcher;
    this.uri = uri;
    this.useApolloNetworkErrorLog = useApolloNetworkErrorLog;
    this.fetchPolyfill = fetchPolyfill;
    return new ApolloClient({
      link: this.link(),
      cache: this.cache()
    });
  }

  _createClass(LumosApolloClient, [{
    key: "cache",
    value: function cache() {
      var fragmentMatcher = this.fragmentMatcher;
      var opts = fragmentMatcher ? {
        fragmentMatcher: fragmentMatcher
      } : {};
      return new InMemoryCache(opts);
    }
  }, {
    key: "link",
    value: function link() {
      var uri = this.uri,
          credentials = this.credentials,
          fetchPolyfill = this.fetchPolyfill,
          useApolloNetworkErrorLog = this.useApolloNetworkErrorLog;
      var httpLinkOpts = {
        uri: uri,
        credentials: credentials
      };

      if (fetchPolyfill) {
        httpLinkOpts.fetch = fetchPolyfill;
      }

      var httpLink = createHttpLink(httpLinkOpts);
      var headersMiddleware = setContext(function () {
        return {
          headers: lumosHeaders
        };
      });
      var baselink = headersMiddleware.concat(httpLink);

      if (useApolloNetworkErrorLog) {
        return ApolloLink.from([errorsMiddleware, baselink]);
      }

      return baselink;
    }
  }]);

  return LumosApolloClient;
}();

export { LumosApolloClient as default };